<div id="related-equipments">
  <div class="container-fluid">
    <div class="row">
      <div class="col">
          <h1>EQUIPAMENTOS ATRELADOS AO PRESTADOR DE SERVIÇO</h1>
      </div>
    </div>

    <div class="row" *ngFor="let related of relatedEquipments; let i = index;">
      <div class="col">
        <div class="row">
          <div class="col">
            <label>
              <span>ÁREA RESPONSÁVEL</span>

              <select [(ngModel)]="related.cdArea" (ngModelChange)="outputEquipments();" [disabled]="isEdit">
                <option value="">Selecione a área responsável</option>
                <option *ngFor="let area of areasArr;" [value]="area.cdArea">{{ area.dsArea }}</option>
              </select>
            </label>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <label>
              <span>EQUIPAMENTO</span>

              <select [(ngModel)]="related.cdProduto" (ngModelChange)="outputEquipments();" [disabled]="isEdit">
                <option value="">Selecione o equipamento</option>
                <option *ngFor="let equipment of equipmentsArr;" [value]="equipment.cdProduto">{{ equipment.dsProduto }}</option>
              </select>
            </label>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <label>
              <span>VALOR MÁXIMO PARA MANUTENÇÃO</span>

              <input type="text" [(ngModel)]="related.vlMaxManutencao" (ngModelChange)="outputEquipments();" currencyMask>
            </label>
          </div>

          <div class="col">
              <label>
                <span>VALOR MÁXIMO PARA MATERIAIS</span>
  
                <input type="text" [(ngModel)]="related.vlMaxMaterial" (ngModelChange)="outputEquipments();" currencyMask>
              </label>
            </div>
        </div>

        <div class="row">
          <div class="col">
            <button class="remove" *ngIf="i > 0" (click)="removeEquipment(i);">REMOVER EQUIPAMENTO</button>
          </div>
        </div>

        <!-- <hr> -->
      </div>
    </div>

    <!-- <div class="row">
      <div class="col">
        <button class="add" (click)="addEquipment();">Adicionar mais equipamentos</button>
      </div>
    </div> -->
  </div>
</div>
